.rkMenu {
  position: fixed;
  position: relative;
  text-align: center;
}

@media (min-width: 1440px) {
  .rkMenu {
    margin-top: 20vh;
    position: fixed;
    text-align: left;
  }
}

.nav {
  display: flex;
  justify-content: center;
  grid-gap: 12px;
  padding-top: 18px;
}

@media (min-width: 1440px) {
  .nav {
    display: block;
    padding-top: 12px;
  }
}


.menuItem {
  transition: all 0.3s ease;
  border-radius: 0.5rem;
  font-size: 32px;
  cursor: pointer;
  font-family: var(--f-family-headline);
}


@media (min-width: 600px) {
  .menuItem {
    padding: 1rem;
    padding-left: 2rem;
  }
}


@media (min-width: 1440px) {
  .menuItem {
    font-size: var(--f-xxl);
    padding-top: 2rem
  }
}
.menuItem.active {
  font-weight: bolder;
}

/* Top Left - Normal text */
.topLeft {
  transform: none;
  color: black;
}

/* Top Right - Text rotated to bottom (90deg clockwise) */
.topRight {
  color: black;
}

/* Bottom Left - Text rotated to top (90deg counter-clockwise) */
.bottomLeft {
  color: black;
}

/* Bottom Right - Text rotated to left (180deg) */
.bottomRight {
  color: black;
}

.logo {
  width: 100px;
  border-radius: 50%;
  margin-top: 50px;
  filter: none;
  border: 1px solid var(--page-background);
}

@media (min-width: 600px) {

  .logo {
    margin-left: 30px;
  }
}